import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getmanagementReviewHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "managementreview", ...action.payload }),
		);
		yield put({
			type: types.GET_MANAGEMENT_REVIEW_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_MANAGEMENT_REVIEW_ERROR,
			payload,
		});
	}
}

export function* getmanagementReviewWatcherSaga() {
	yield takeLatest(
		types.GET_MANAGEMENT_REVIEW_START,
		getmanagementReviewHandlerSaga,
	);
}

//create

//delete

function* deletemanagementReviewHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("managementreview", action.payload),
		);
		yield put({
			type: types.DELETE_MANAGEMENT_REVIEW_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_MANAGEMENT_REVIEW_ERROR,
			payload,
		});
	}
}

export function* deletemanagementReviewWatcherSaga() {
	yield takeLatest(
		types.DELETE_MANAGEMENT_REVIEW_START,
		deletemanagementReviewHandlerSaga,
	);
}

//update
